import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity, updateEntity, createEntity, reset } from './support.reducer';
import { ISupport } from 'app/shared/model/support.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const SupportUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const supportEntity = useAppSelector(state => state.support.entity);
  const loading = useAppSelector(state => state.support.loading);
  const updating = useAppSelector(state => state.support.updating);
  const updateSuccess = useAppSelector(state => state.support.updateSuccess);

  const handleClose = () => {
    props.history.push('/support' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...supportEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...supportEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="korischoolApp.support.home.createOrEditLabel" data-cy="SupportCreateUpdateHeading">
            <Translate contentKey="korischoolApp.support.home.createOrEditLabel">Create or edit a Support</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="support-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('korischoolApp.support.nfc1')} id="support-nfc1" name="nfc1" data-cy="nfc1" type="text" />
              <ValidatedField label={translate('korischoolApp.support.nfc2')} id="support-nfc2" name="nfc2" data-cy="nfc2" type="text" />
              <ValidatedField label={translate('korischoolApp.support.nfc3')} id="support-nfc3" name="nfc3" data-cy="nfc3" type="text" />
              <ValidatedField
                label={translate('korischoolApp.support.qrcode')}
                id="support-qrcode"
                name="qrcode"
                data-cy="qrcode"
                type="text"
              />
              <ValidatedField
                label={translate('korischoolApp.support.statut')}
                id="support-statut"
                name="statut"
                data-cy="statut"
                check
                type="checkbox"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/support" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                style={{ backgroundColor: '#F28E19', color: 'white' }}
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SupportUpdate;
